import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="552.305"
      height="1794.45"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 552.305 1794.45"
      xmlSpace="preserve"
      className='clickable'
    >
      <clipPath id="ArtboardFrame">
        <path d="M0 0H2800V2160H0z"></path>
      </clipPath>
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#ArtboardFrame)"
        transform="translate(-565.204 -365.55)"
      >
        <path
          strokeWidth="2.5"
          d="M795.9 372.4c-12.6 3.733-22.4 7.933-29.4 12.6s-12.833 9.333-17.5 14-10.5 13.067-17.5 25.2-11.667 24.267-14 36.4-4.9 19.133-7.7 21c-2.8 1.867-5.367 5.133-7.7 9.8-2.333 4.667-3.267 12.367-2.8 23.1.467 10.733 3.267 18.667 8.4 23.8 5.133 5.133 9.333 12.367 12.6 21.7 3.267 9.333 9.1 18.433 17.5 27.3s12.833 15.4 13.3 19.6c.467 4.2 5.133 9.1 14 14.7s14.933 8.4 18.2 8.4c3.267 0 6.067-.933 8.4-2.8 2.333-1.867 3.733-5.367 4.2-10.5.467-5.133.233-8.4-.7-9.8-.933-1.4-5.367-4.433-13.3-9.1-7.933-4.667-15.167-7-21.7-7-6.533 0-12.133-2.567-16.8-7.7-4.667-5.133-8.867-11.433-12.6-18.9-3.733-7.467-5.6-11.667-5.6-12.6v-1.4l3.5.7c2.333.467 3.967-.233 4.9-2.1l1.4-2.8 2.1 3.5c1.4 2.333 3.033 3.733 4.9 4.2 1.867.467 3.967.233 6.3-.7 2.333-.933 3.967-2.333 4.9-4.2.933-1.867.933-13.767 0-35.7-.933-21.933-3.267-33.833-7-35.7-3.733-1.867-7.233-1.4-10.5 1.4l-4.9 4.2v-4.2c0-2.8 2.1-11.2 6.3-25.2 4.2-14 10.267-25.9 18.2-35.7 7.933-9.8 14.7-16.567 20.3-20.3 5.6-3.733 12.833-7 21.7-9.8 8.867-2.8 16.1-4.433 21.7-4.9 5.6-.467 13.067 0 22.4 1.4 9.333 1.4 17.267 3.267 23.8 5.6 6.533 2.333 13.067 5.6 19.6 9.8 6.533 4.2 12.133 8.633 16.8 13.3 4.667 4.667 9.1 10.733 13.3 18.2 4.2 7.467 7.233 14.467 9.1 21 1.867 6.533 2.8 15.633 2.8 27.3 0 11.667-1.4 22.167-4.2 31.5-2.8 9.333-5.6 16.333-8.4 21l-4.2 7-2.1-6.3c-1.4-4.2-3.967-6.533-7.7-7-3.733-.467-6.3-.233-7.7.7-1.4.933-8.167 9.567-20.3 25.9-12.133 16.333-18.2 26.133-18.2 29.4 0 3.267.7 5.6 2.1 7 1.4 1.4 3.5 2.333 6.3 2.8 2.8.467 4.9.233 6.3-.7l2.1-1.4-.7 3.5c-.467 2.333 1.867 4.2 7 5.6 5.133 1.4 10.5 1.867 16.1 1.4 5.6-.467 10.033-1.867 13.3-4.2 3.267-2.333 7.467-7 12.6-14s7.933-13.767 8.4-20.3c.467-6.533.233-10.733-.7-12.6-.933-1.867.467-6.3 4.2-13.3 3.733-7 6.767-15.167 9.1-24.5 2.333-9.333 3.033-21.7 2.1-37.1-.933-15.4-2.333-25.9-4.2-31.5-1.867-5.6-5.367-12.6-10.5-21s-10.5-15.4-16.1-21c-5.6-5.6-13.067-11.2-22.4-16.8-9.333-5.6-19.133-9.8-29.4-12.6-10.267-2.8-20.3-4.2-30.1-4.2s-21 1.867-33.6 5.6z"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M699 521s-1.75 22.75-13 45c-4.488 8.876-12.409 15.632-18 23-8.425 11.102-14 21-14 21l11-9v4l-20 20s-9.25 11.5-19 19-20 11-20 11-7 3.5-11 8-5 10-5 10 .75 3-2 9-12.5 20.5-17 48-4 28-1 62c4.315 48.898 26 151 55 208 26.006 51.12 38 11 84-3 40.859-12.435 102-50 102-50"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M928 565s5.5 29.5 5 48-7 26-7 26l-4 15s-1.835.911-3 0c-1.49-1.166-2.439-4.122-3-3-1.474 2.947.632 9.45 1 16 .552 9.843-4 23-4 23l-1-26-3-5s-3 10 4 35c2.11 7.537 7.182 13.84 10 22 6.528 18.904 10.461 40.974 15 44 3 2 2 7 2 9 0 3.553 2 4 2 7"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M635 1017c-5 39-14 37-20 116-3.16 41.61-8.52 103.93-10 161-1.947 75.05 2.509 128.95 2 170-.279 22.53-5.176 51.59-2 59 3 7 19.774 7.32 31 9 67 10 89.745 18.03 153 19 65 1 74-4 101-23 13.526-9.52 12.677-31.94 11-42-2-12 3-51 3-51s11-111.48 11-169c0-53 0-39.5-2-79s-6-79-6-79l-7-107"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M664 1538s2.6 23.47 2 59c-.462 27.33-5.413 61.61 1 99 14.75 86 31 108 57 191 7.328 23.39-1.886 29.95-10 45-9.007 16.71-23.236 27.61-21 48 4.25 38.75 8 90 27 122 7.59 12.78 27.5-1.5 42 8s8 20 16 30 7.75 5.25 16 10 17 9 17 9"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M843 1550s3.75 10 2 20-9 20-9 20 3.629 48.61-7 105c-10.937 58.02-20 118-31 188-1.087 6.92 4.225 24.93 7 34 5.235 17.1 11.929 29.98 25 62 25.831 63.29 46 110 46 110s29 8.75 31 26-23 43-23 43"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M875 967s12.832 20.95 27 32c16.514 12.88 39.544 23.13 53 23 16.782-.17 25.038-30.856 23-62-.671-10.261-8.446-25.271-10-37-.756-5.705 5-13.386 5-15"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M681.355 790.675c.089 36.608 4.708 86.153 7.645 122.325"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M812.911 925.284c-3.985 2.616 1.037 19.375 3.975 22.355C828.243 959.16 860.408 958.104 874 966"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M785.052 1553.04c0 7.5.427 16.89-1.037 24.22-.908 4.53-3.25 8.98-4.152 13.49-.63 3.15-1.207 10.2-3.46 12.45"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M776.749 1602.86c-1.789 3.58 2.304 16.01 3.114 20.06 3.435 17.18 6.554 35.45 8.303 52.94 6.255 62.54 11.071 126.19 11.071 189.58"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M717.729 1929.87c-1.078 0-.725-.2-.3 1.5 1.772 7.09 5.673 14.19 8.414 21.04 5.991 14.98 11.819 30.78 21.636 43.87 9.265 12.36 12.968 28.51 18.631 42.67 4.707 11.77 10.054 23.26 15.025 34.86 1.423 3.32 4.547 5.18 6.31 8.11 2.533 4.23 4.924 8.96 9.015 12.02 15.888 11.92 39.039 12.81 57.997 9.02 6.08-1.22 10.374-4.93 15.025-8.41 1.457-1.1 4.323-6.06 3.906-4.81"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M697.896 1993.88c-1.643 0 .869.95 1.202 1.2 2.219 1.66 4.213 3.67 6.611 5.11 5.528 3.31 11.029 6.62 16.528 9.91 15.627 9.38 34.795 22.96 40.868 41.17"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M788.441 2117.8c.078-1.04 1.277 3.48 2.227 4.59 2.817 3.27 3.926 7.1 8.491 9.02 12.523 5.25 24.978 1.99 38.023.62 10.268-1.08 20.649-3.69 30.62-6.2 4.61-1.16 9.587-1.23 14.074-2.9 5.124-1.91 10.567-1.56 15.942-2.3 2.025-.27 4.553-.97 6.279-1.9.399-.21 1.286-.43 1.286-.43s-.598.43-.781.73"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M863.991 2055.47c-.955-.33 1.055.38 1.212.42 1.08.27 2.048.93 3.049 1.18 2.556.65 9.439 3.08 12.748 8.93 3.309 5.85.901 10.82.49 14.46-.03.26 1.509 1.45 1.704 1.94.91 2.3.338 4.34-.426 6.56"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M874.786 2080.05c1.559 2.3 5.29 1.18 7.348.9"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M939 935l168-142s9.25-7.75 9-10-10-2-10-2-44.53 2.465-80 3c-9.98.151-19 1-27 2-.992.124-10 1-24 13-26.887 23.046-87 75-87 75"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M762 412c14.468-10.288 32.445-18.419 44-22 24.385-7.557 44.528 1.764 49 4 14 7 56 22 68 105"
          opacity="1"
        ></path>
        <path strokeWidth="3" d="M945 941l-32-20" opacity="1"></path>
        <path
          strokeWidth="3"
          d="M812.824 925.701c2.029-4.059 10.135-9.835 13.9-4.565 1.546 2.165-.914 10.505.415 13.693.574 1.38 4.12 6.143 6.224 4.565 3.765-2.825-3.994-15.305-4.357-19.295-.767-8.438 5.199-6.352 7.987-11.929 1.481-2.961 1.399-6.387 3.631-9.025 2.618-3.094 6.081-3.053 9.129-5.187 1.904-1.333 1.772-4.527 2.801-6.328 1.725-3.018 8.716-6.823 12.033-6.638 3.823.212 6.397 5.112 10.892 4.875 3.681-.194 1.896-3.66 3.423-5.187 3.099-3.099 7.934-4.268 12.137-3.527 5.967 1.053.449 8.29 3.423 10.892 2.913 2.549 7.187 1.834 10.166 4.565 8.105 7.429 6.61 11.284 7.261 21.058.154 2.305 1.452 4.663 1.452 6.846"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M965.066 805.608c1.555-1.16-2.317-3.625-2.851-3.997-4.287-2.984-8.256-2.326-11.713-6.678-1.378-1.735-1.599-4.388-2.483-6.356-3.197-7.116-5.701-13.929-14.458-13.619-7.02.248-14.274 7.317-19.39 11.38-5.441 4.321-11.939 6.489-16.801 11.708-2.058 2.208-2.453 4.795-3.737 7.39-3.188 6.449-5.95 13.183-7.96 20.008"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M885.495 825.732c-2.691 10.765-8.583 23.594-17.757 30.475-6.907 5.18-15.387 7.693-23.036 11.518-12.741 6.37-25.896 13.287-39.353 17.997-9.685 3.389-19.32 7.227-28.915 10.918-3.439 1.322-6.836 2.105-10.198 3.719-.845.406-4.285 1.851-4.08 1.92"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M762.862 901.811c-3.148 2.601-14.497 4.265-18.591 5.034-16.512 3.1-33.256 5.087-49.851 7.559-7.242 1.079-16.21 2.14-22.683 5.719a63.843 63.843 0 00-6.574 4.152c-.5.359-2.32 1.916-2.308 1.906"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M800.464 619.165c16.988-2.82 37.091-15.481 47.248-29.681"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;